import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import axios from "axios";

import { GroupContainer } from "./component/styled/common";
import { DeleteMessage, GroupTitle } from "./component/styled/groupDetails";
import { hideLoading, showLoading } from "../../store/loading";

import PageInfo from "./component/common/pageInfo";
import Join from "./component/groupDetails/join";
import HamburgerMenu from "./component/common/hamburgerMenu";

import { FiHome, FiSearch, FiSettings, FiUsers } from "react-icons/fi";
import { IoIosChatboxes } from "react-icons/io";

const GroupDetails = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const display = location.state?.display;

  const user = useSelector((state) => state?.user?.data[0]);

  const [group, setGroup] = useState({});
  const [members, setMembers] = useState([]);
  const [viewJoinButton, setViewJoinButton] = useState(false);
  const [isJoin, setIsJoin] = useState(false);
  const [member, setMember] = useState(null);

  const tabs = [
    { name: "홈", icon: FiHome },
    { name: "커뮤니티", icon: IoIosChatboxes, path: "/community" },
    { name: "검색", icon: FiSearch, path: "/search" },
    { name: "멤버", icon: FiUsers, path: "/members" },
    { name: "설정", icon: FiSettings, path: "/settings" },
  ];

  const currentTab = tabs.find((tab) => location.pathname.includes(tab.path)) || tabs[0];

  useEffect(() => {
    if (!checkParam()) {
      return;
    }
    getGroupDetail();
  }, [id]);

  const checkParam = () => {
    if (isNaN(id) || id === "0") {
      navigate("/group");
      return false;
    }
    return true;
  };

  // 모임 조회
  const getGroupDetail = async () => {
    dispatch(showLoading());
    const url = "/api/groupList";
    const req = getDataCond();

    try {
      const res = await axios.post(url, req);
      const data = res?.data?.content[0];

      if (data) {
        setGroup(data);
        getGroupMembers(data);
      } else {
        toast.error("존재하지 않는 모임입니다.", { toastId: "no-access" });
        navigate("/group");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // 모임 멤버 조회
  const getGroupMembers = async (grp, member = null) => {
    const url = "/api/groupMberList";
    const req = getDataCond();
    try {
      const res = await axios.post(url, req);
      const data = res?.data?.content;

      if (data) {
        setMembers(data);

        const mber = data?.filter(
          (item) => item?.mberNo === user?.mberNo || (member && item?.mberNo === member?.mberNo),
        )?.[0];

        if (mber) {
          setMember(mber);
          setViewJoinButton(false);
        } else {
          setMember(null);

          if (grp.displayYn === "N" && !display) {
            toast.error("해당 모임은 비공개 모임입니다.", { toastId: "no-access" });
            navigate("/group");
          }

          getApplyMembers(grp);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(hideLoading());
    }
  };

  const getApplyMembers = async () => {
    const url = "/api/groupMberList";
    const body = getDataCond();
    body.approvalYn = "N";

    try {
      const res = await axios.post(url, body);
      const data = res?.data?.content || [];
      const mber = data?.filter((item) => item?.mberNo === user?.mberNo)?.[0];

      if (!mber) {
        if (currentTab.name !== "홈") {
          navigate(`/group/${id}`);
        }
        setViewJoinButton(true);
      }
    } catch (error) {}
  };

  const getDataCond = () => {
    return {
      groupNo: id,
      offset: 0,
      delYn: "N",
      pageNumber: 0,
      pageSize: 1,
      paged: false,
    };
  };

  const tabClick = (item) => {
    navigate(`/group/${id}${item.path ? item.path : ""}`);
  };

  return (
    <GroupContainer>
      <div className="inner">
        <>
          <PageInfo title={group.groupName} />
          {group.delDt && (
            <DeleteMessage>
              <span>해당 모임은 </span>
              <span>
                <strong className="time">{moment(group.delDt).format("M월 D일 H시 m분")}</strong>에
                삭제될 예정입니다.
              </span>
            </DeleteMessage>
          )}
          <GroupTitle>{currentTab.name}</GroupTitle>
          <HamburgerMenu currentTab={currentTab} member={member} tabs={tabs} tabClick={tabClick} />
          <Outlet context={{ group, members, member, getGroupDetail, getGroupMembers }} />
        </>
        {viewJoinButton && (
          <Join
            member={member}
            grp={group}
            getGrpMbers={getGroupMembers}
            getGroupDetail={getGroupDetail}
            isJoin={isJoin}
            setIsJoin={setIsJoin}
          />
        )}
      </div>
    </GroupContainer>
  );
};

export default GroupDetails;
